function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsxs as u, Fragment as C, jsx as t } from "react/jsx-runtime";
import E from "classnames";
import { useTheme as N, useScreenSize as V } from "./hooks.js";
import x from "./badge.js";
import n from "./box.js";
import { Text2 as y } from "./text.js";
import z from "./icon-button.js";
import j from "./generated/mistica-icons/icon-close-regular.js";
import { pxToRem as p } from "./utils/css.js";
import { iconActive as O, icon as S, chipVariants as i, button as D, chipInteractiveVariants as L } from "./chip.css-mistica.js";
import { vars as M } from "./skins/skin-contract.css-mistica.js";
import { getPrefixedDataAttributes as g } from "./utils/dom.js";
import { useThemeVariant as W } from "./theme-variant-context.js";
import { BaseTouchable as v } from "./touchable.js";
const F = (e)=>{
    const { Icon: c , children: P , id: k , dataAttributes: l , active: s , badge: r , onClose: d  } = e, { texts: T , isDarkMode: A , textPresets: I  } = N(), m = W() === "alternative", { isTabletOrSmaller: a  } = V(), f = c ? a ? 16 : 8 : a ? 20 : 12, R = a ? 20 : 12, b = a ? 16 : 8, w = ()=>r ? /* @__PURE__ */ t(C, {
            children: r === !0 ? /* @__PURE__ */ t(x, {}) : /* @__PURE__ */ t(x, {
                value: r
            })
        }) : null, h = /* @__PURE__ */ u(C, {
        children: [
            c && /* @__PURE__ */ t(n, {
                paddingRight: 4,
                className: s ? O : S,
                children: /* @__PURE__ */ t(c, {
                    color: "currentColor",
                    size: p(16)
                })
            }),
            /* @__PURE__ */ t(n, {
                paddingRight: r ? 8 : d ? 4 : 0,
                children: /* @__PURE__ */ t(y, {
                    id: k,
                    weight: I.indicator.weight,
                    truncate: 1,
                    color: "currentColor",
                    children: P
                })
            })
        ]
    });
    if (r) return /* @__PURE__ */ u(n, _object_spread_props(_object_spread({
        className: m ? i.overAlternative : i.default,
        paddingLeft: f,
        paddingRight: b
    }, g(l, "Chip")), {
        children: [
            h,
            w()
        ]
    }));
    if (d) return /* @__PURE__ */ u(n, _object_spread_props(_object_spread({
        className: m ? i.overAlternative : i.default,
        paddingLeft: f,
        paddingRight: b
    }, g(l, "Chip")), {
        children: [
            h,
            /* @__PURE__ */ t(z, {
                size: 24,
                style: {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                },
                "aria-label": T.closeButtonLabel,
                onPress: ()=>d(),
                children: /* @__PURE__ */ t(j, {
                    size: 16,
                    color: M.colors.neutralMedium
                })
            })
        ]
    }));
    const B = s !== void 0 || e.href || e.onPress || e.to, o = ()=>/* @__PURE__ */ t(n, _object_spread_props(_object_spread({
            className: E(i[s ? "active" : m ? "overAlternative" : "default"], {
                [L[A ? "dark" : "light"]]: B
            }),
            paddingLeft: f,
            paddingRight: R
        }, g(l, "Chip")), {
            children: h
        }));
    return e.onPress ? /* @__PURE__ */ t(v, {
        className: D,
        trackingEvent: e.trackingEvent,
        onPress: e.onPress,
        children: o()
    }) : e.to ? /* @__PURE__ */ t(v, {
        trackingEvent: e.trackingEvent,
        to: e.to,
        fullPageOnWebView: e.fullPageOnWebView,
        children: o()
    }) : e.href ? /* @__PURE__ */ t(v, {
        trackingEvent: e.trackingEvent,
        href: e.href,
        newTab: e.newTab,
        children: o()
    }) : o();
}, re = F;
export { re as default };
